<template>
    <div>
        <div class="modal fade" id="recordsJm" tabindex="-1" aria-labelledby="myAccountLabel" aria-hidden="true"
            data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-lg" style="min-width: 90vw;">
                <div class="modal-content p-0" :style="skin.my_account.modal_background" style="min-height:95vh">
                    <div class="text-end p-1" style="background-color: #b3aeae;">
                        <button id="closeRecordsBtn" :style="skin.my_account.close_btn" style="background:black;float: right;color:white;"
                            class="btn btn-sm" type="button" data-bs-dismiss="modal" aria-label="Close"><i
                                class="fas fa-times"></i></button>
                    </div>
                    <div class="m-1 p-1" :style="skin.qbet.fondo3">
                        <div class="text-center py-1 pb-2" style="border-bottom: solid 1px #f3dd16;">
                            {{ translate('betting') }}
                        </div>
                        <div class="row p-2" :style="skin.qbet.fondo1">
                            <div class="col-12 col-lg-3">
                                <span>{{ translate('date') }}</span><br>
                                <date-picker v-model="date_range" type="date" range placeholder="" style="max-width:100%;"
                                    class="mb-2"></date-picker>
                            </div>
                            <div class="col-12 col-lg-3">
                                <span>{{ translate('state') }}</span><br>
                                <select @change="select_status()" id="statusSelect" class="form-control p-1 mb-1"
                                    aria-label="Default select example">
                                    <option value="-1" selected>{{ translate("all") }}</option>
                                    <option value="1">{{ translate("pendings") }}</option>
                                    <option value="2">{{ translate("won") }}</option>
                                    <option value="4">{{ translate("losses") }}</option>
                                    <option value="7">{{ translate("CashOut") }}</option>
                                    <option value="0">{{ translate("returned") }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-lg-3">
                                <span>{{ translate('check_number') }}</span><br>
                                <input class="form-control p-1 mb-1" :placeholder="translate('ticket_id')" type="number"
                                    v-model="ticket_id" />
                            </div>
                            <div class="col-12 col-lg-3">
                                <br>
                                <button @click="get_tracking('from_scratch')" :style="skin.qbet.confirm_btn"
                                    class="p-1 text-center mb-2" style="width:50%;color:white"
                                    :disabled="loading_tracking">{{ translate("show") }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="py-1 m-1">
                        <div v-if="Object.keys(bet_tracking.tickets).length > 0 && screen_width >=700">
                            <div class="p-1 table-responsive" >
                                <table class="table">
                                    <thead style="color:#ccc">
                                        <th style="width: 10%;">{{ translate("date") }}</th>
                                        <th style="width: 10%;">Bet Slip</th>
                                        <th style="width: 10%;">{{ translate('type_of_bet') }}</th>
                                        <th style="width: 10%;">{{ translate('amount') }}</th>
                                        <th style="width: 10%;">{{ translate('expected_earning_sportium') }}</th>
                                        <th style="width: 10%;">{{ translate('gain1') }}</th>
                                        <th style="width: 10%;">Cashout</th>
                                        <th style="width: 10%;">{{ translate('state') }}</th>
                                        <th style="width: 10%;"></th>
                                        <th style="width: 1.2%;"></th>
                                    </thead>
                                </table>
                            </div>
                            <!-- <div class="p-2 text-center" v-if="user.user_data.data">
                                <span>{{ user.user_data.data.rol == 'RESELLER' ? translate('sold') : translate('staked') }} {{
                                    sold }}</span>&nbsp;&nbsp;
                                <span>{{ user.user_data.data.rol == 'RESELLER' ? translate('paid') : translate('won2') }} {{ paid
                                }}</span>&nbsp;&nbsp;
                                <span v-if="user.user_data.data.rol == 'RESELLER'">Total: {{ (sold - paid).toFixed(2) }}</span>
                            </div> -->
                            <div v-if="filtered_tracking.length > 0 && screen_width >= 700">
                                <tracking_jm v-for="(ticket, index) in filtered_tracking" :key="ticket.id"
                                    v-bind:ticket_data="ticket" v-bind:Skin="skin" v-bind:language="language"
                                    v-bind:translation="translation" v-bind:index="index"
                                    v-bind:currentOdds="bet_tracking.currentOdds" v-bind:source="source" />
                            </div>
                            <div v-if="filtered_tracking.length < 1" class="text-center p-3">
                                {{ translate("no_search_results") }}
                            </div>
                        </div>
                        <div v-if="Object.keys(bet_tracking.tickets).length > 0 && screen_width < 700">
                            <div v-if="filtered_tracking.length > 0 && screen_width<700">
                                <tracking v-for="(ticket, index) in filtered_tracking" :key="ticket.id"
                                    v-bind:ticket_data="ticket" v-bind:Skin="skin" v-bind:language="language"
                                    v-bind:translation="translation" v-bind:index="index"
                                    v-bind:currentOdds="bet_tracking.currentOdds" v-bind:source="source" />
                            </div>
                            <div v-if="filtered_tracking.length < 1" class="text-center p-3">
                                {{ translate("no_search_results") }}
                            </div>
                        </div>
                    </div>
                    <div v-if="Object.keys(bet_tracking.tickets).length < 1" style="width:100%" class="text-center p-2">
                        <div class="spinner-border" :style="skin.loader" role="status">
                            <span class="visually-hidden">{{ translate('loading') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import navigationBar from './navigation_bar.vue';
import tracking_jm from '../../main_bet/tracking_jm.vue';
import tracking from '../../main_bet/tracking.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es/es';
export default {
    name: "main_records_jm",
    props: ['skin', 'translation', 'language', 'user_id', 'source'],
    components: { navigationBar, tracking_jm, DatePicker, tracking },
    data() {
        return {
            screen_width:0,
            interval: "",
            bet_tracking: {
                "tickets": {},
                "currentOdds": {}
            },
            loading_tracking: false,
            filtered_tracking: {},
            ticket_status: -1,
            date_range: [],
            ticket_id: "",
            sold: 0,
            paid: 0
        }
    },
    computed: {
        hoverCss() {
            return {
                '--fondoH': this.$props.skin.prematch_all_odds.hover_fondo,
                '--textH': this.$props.skin.prematch_all_odds.hover_text,
            }
        },
        user() {
            return this.$store.getters['getUserData'];
        },
    },
    methods: {
        sizeControl(){
            this.screen_width=window.innerWidth;
        },
        async get_tracking(type) {
            if(this.user.token=="") return
            let dateFrom = this.date_range[0];
            let dateTo = this.date_range[1];
            let data = {
                from: Math.floor(dateFrom.getTime() / 1000),
                to: Math.floor(dateTo.getTime() / 1000),
            }
            if (type == "from_scratch") {
                this.bet_tracking = {
                    "tickets": {},
                    "currentOdds": {}
                }
            }
            if (this.$props.user_id.id) {
                data['user_id'] = this.$props.user_id.id;
            }
            if (this.ticket_id != "") {
                data['bet_id'] = this.ticket_id;
            }
            let tracking = await this.$store.dispatch('getTracking', data);
            if(tracking){
                let odd_ids = [];
                this.sold = parseFloat(tracking.data.vendido ? tracking.data.vendido : 0).toFixed(this.$props.skin.qBet_config.decimalsQty);
                this.paid = parseFloat(tracking.data.pagado ? tracking.data.pagado : 0).toFixed(this.$props.skin.qBet_config.decimalsQty);
                tracking.data.bets.forEach(pendingT => {
                    pendingT.events.forEach(odd => {
                        if (odd.status == 1) {
                            odd_ids.push(odd.id);
                        }
                    })
                })
                odd_ids = [...new Set(odd_ids)];
                let currentOddData = await this.$store.dispatch('getOddData', odd_ids);
                tracking.data.bets = tracking.data.bets.reverse()
                this.bet_tracking.tickets = tracking;
                this.bet_tracking.currentOdds = currentOddData;
                let filtered = [];
                if (this.ticket_status != -1) {
                    tracking.data.bets.forEach(ticket => {
                        if (this.ticket_status == 2) {
                            if (ticket.status == 2 || ticket.status == 5 || ticket.status == 3) {
                                filtered.push(ticket);
                            }
                        }
                        else {
                            if (ticket.status == this.ticket_status) {
                                filtered.push(ticket);
                            }
                        }
                    });
                    this.filtered_tracking = filtered;
                }
                else {
                    this.filtered_tracking = tracking.data.bets;
                }
            }
        },
        hover: function (id) {
            document.getElementById(id).classList.add('hover');
        },
        hover2: function (id) {
            document.getElementById(id).classList.remove('hover');
        },
        select_status() {
            let status = document.getElementById("statusSelect").value;
            clearInterval(this.interval);
            this.ticket_status = status;
            let self = this;
            if (this.ticket_status == -1 || this.ticket_status == 1) {
                this.interval = setInterval(function () {
                    self.get_tracking('');
                }, 60000)
            }
            this.get_tracking('from_scratch');
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        }
    },
    mounted() {
        window.addEventListener('resize', ()=>{this.sizeControl();});
        this.$root.$on('refresh_records', () => {
            this.get_tracking('from_scratch');
        });
        let dateFrom = new Date();
        dateFrom.setDate(dateFrom.getDate() - 1);
        let dateTo = new Date();
        dateTo.setDate(dateTo.getDate());
        this.date_range = [dateFrom, dateTo];
        this.get_tracking('');
        let self = this;
        this.interval = setInterval(function () {
            self.get_tracking('');
        }, 60000)
    },
    created(){
        this.sizeControl();
    },
    destroyed() {
        clearInterval(this.interval);
    }
}
</script>
  
<style scoped>.hover {
    background-color: var(--fondoH);
    color: var(--textH) !important;
}</style>